import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

// Single-origin cookie auth: send cookies, never store bearer tokens.
const api = axios.create({ baseURL: API_BASE, withCredentials: true });

function getCookie(name) {
  const m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
  return m ? decodeURIComponent(m.pop()) : null;
}

const MUTATING = ["post", "put", "patch", "delete"];

api.interceptors.request.use((config) => {
  if (MUTATING.includes((config.method || "").toLowerCase())) {
    const isPosRequest = (config.url || "").startsWith("/pos");
    const csrf = isPosRequest
      ? (getCookie("mayr_cashier_csrf") || getCookie("mayr_csrf"))
      : getCookie("mayr_csrf");
    if (csrf) config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});

let refreshPromise = null;

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const cfg = err.config || {};
    const status = err.response?.status;
    const path = window.location.pathname;
    const isAuthCall = cfg.url && (cfg.url.includes("/auth/login") || cfg.url.includes("/auth/refresh"));
    if (status === 401 && path.startsWith("/pos/station") && !cfg._skipAuthRedirect) {
      window.location.reload();
      return Promise.reject(err);
    }
    if (status === 401 && !cfg._retry && !cfg._skipAuthRedirect && !isAuthCall) {
      cfg._retry = true;
      try {
        refreshPromise = refreshPromise || api.post("/auth/refresh");
        await refreshPromise;
        refreshPromise = null;
        return api(cfg);
      } catch (e) {
        refreshPromise = null;
        if (!path.startsWith("/login") && !path.startsWith("/q/") && !path.startsWith("/appointment/") && !path.startsWith("/invite")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export function apiErrorMessage(err, t) {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (typeof detail === "string") {
    const translated = t ? t(`errors.${detail}`) : null;
    if (translated && !translated.startsWith("errors.")) return translated;
    return detail;
  }
  if (detail && typeof detail === "object" && typeof detail.code === "string") {
    const translated = t ? t(`errors.${detail.code}`) : null;
    const message = translated && !translated.startsWith("errors.") ? translated : detail.code;
    return detail.job_number ? `${message} (${detail.job_number})` : message;
  }
  return err?.message || "Error";
}

export default api;
